import * as pluralize from 'pluralize'


export const plural = (count: number, word: string) => {
  if (count === 1) return pluralize.singular(word)
  return pluralize.plural(word)
}
